/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ExpandableTagQuery } from "~/generated/graphql";
import { isNotNil } from "~/tools";

type FieldPreset = {
  isApp: boolean;
  isEnv: boolean;
  isCategory: boolean;
  isPolicy: boolean;
  isExternal: boolean;
};

export function mapData(
  data: ExpandableTagQuery | undefined,
  { isApp, isEnv, isCategory, isPolicy, isExternal }: FieldPreset,
  value: string[]
) {
  if (isApp) {
    return data?.applicationsByIds?.filter(isNotNil).map(({ nid, name }) => ({
      nid,
      name,
    }));
  }
  if (isEnv) {
    return data?.environmentsByIds?.filter(isNotNil).map(({ nid, name }) => ({
      nid,
      name,
    }));
  }
  if (isCategory) {
    return data?.categoriesByIds
      ?.filter(({ id }) => value.includes(id))
      .map(({ id, name }) => ({
        nid: id,
        name,
      }));
  }
  if (isPolicy) {
    return data?.cloudWasteSummary?.policies
      ?.filter(isNotNil)
      .filter(({ id }) => value.includes(id ?? ""))
      .map(({ id, title }) => ({
        nid: id?.toString() ?? "",
        name: title ?? "",
      }));
  }
  if (isExternal) {
    return data?.externalIntegrations?.integrations
      ?.filter(isNotNil)
      .filter(({ id }) => value.includes(id))
      .map(({ id, name }) => ({
        nid: id,
        name,
      }));
  }
}
